/**
 * Constants for bed environment charts
 */

export const BED_METRICS = [
  { key: 'moisturePct', label: 'Влажность', color: '#1677ff', unit: '%' },
  { key: 'soilTempC', label: 'Температура почвы', color: '#f5222d', unit: '°C' },
  { key: 'pH', label: 'pH', color: '#52c41a', unit: '' },
  { key: 'nitrogen', label: 'Азот (N)', color: '#389e0d', unit: 'мг/кг' },
  { key: 'phosphorus', label: 'Фосфор (P)', color: '#fa8c16', unit: 'мг/кг' },
  { key: 'potassium', label: 'Калий (K)', color: '#722ed1', unit: 'мг/кг' },
] as const;

export type BedMetricKey = typeof BED_METRICS[number]['key'];

export const FIELD_METRICS = [
  { key: 'snowDepthCm', label: 'Снежный покров', color: '#91caff', unit: 'см' },
  { key: 'frostDepthCm', label: 'Глубина промерзания', color: '#69b1ff', unit: 'см' },
  { key: 'cumulativeGDD', label: 'Сумма активных температур', color: '#f5222d', unit: '°C·дн' },
] as const;

export type FieldMetricKey = typeof FIELD_METRICS[number]['key'];

export const BED_TIMESERIES_PROPERTIES = BED_METRICS.map(m => m.key);
